import { SERVICES } from "./services";

// Hand-picked before/after sliders for the homepage strip.
// Each entry points at a service slug, a project index and (optionally) which slider within that project.
const PICKS = [
  { slug: "custom-mirror-installation-sydney", project: 0 }, // Kirribilli gable mirror
  { slug: "glass-grab-rails-sydney", project: 4, slider: 0 }, // Leichhardt iron -> glass
  { slug: "stainless-steel-fabrication-sydney", project: 0 }, // Tennyson Point curved stair
  { slug: "glass-replacement-sydney", project: 2 }, // Glenhaven shattered door
  { slug: "glass-grab-rails-sydney", project: 5, slider: 0 }, // Strathfield floating stair
  { slug: "custom-mirror-installation-sydney", project: 5 }, // Auburn barber arches
  { slug: "frameless-glass-balustrades-sydney", project: 2 }, // Whale Beach
  { slug: "glass-replacement-sydney", project: 3 }, // Palm Beach crane
];

export const SHOWCASE = PICKS.map(({ slug, project, slider = 0 }) => {
  const service = SERVICES.find((s) => s.slug === slug);
  const p = service.projects[project];
  const ba = [].concat(p.beforeAfter)[slider];
  return {
    key: `${slug}-${project}-${slider}`,
    title: p.title,
    service: service.name,
    href: `/services/${slug}`,
    before: ba.before,
    after: ba.after,
    beforeLabel: ba.beforeLabel,
  };
});
